import { z } from 'zod';

export const formSchema = z.object({
  nombre: z.string().min(3, 'El nombre debe tener al menos 3 caracteres',),
  calle: z.string().min(1, 'La calle es obligatoria'),
  num_exterior: z.string().min(1, 'El número exterior es obligatorio'),
  colonia: z.string().min(1, 'La colonia es obligatoria'),
  codigo_postal: z.string().min(1, 'El código postal es obligatorio'),
  ciudad: z.string().min(1, 'La ciudad es obligatoria'),
  estado: z.string().min(1, 'El estado es obligatorio'),
});